(() => {
 const collectionPath = /\/collections\/[^/]+/;
 function prepareLink(link) {
  if (!link?.href) return;
  const url = new URL(link.href, location.origin);
  if (url.origin !== location.origin || !collectionPath.test(url.pathname) || url.pathname.includes('/products/')) return;
  url.searchParams.set('filter.v.availability', '1');
  link.href = url.href;
 }
 document.addEventListener('click', event => prepareLink(event.target.closest('a')), true);
 document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a[href]').forEach(prepareLink);
  document.querySelectorAll('form[action]').forEach(form => {
   const url = new URL(form.action, location.origin);
   if (url.origin !== location.origin || !url.pathname.endsWith('/search')) return;
   let input = form.querySelector('[name="options[unavailable_products]"]');
   if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'options[unavailable_products]'; form.append(input); }
   input.value = 'hide';
  });
 });
})();
